import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { object, array, func } from 'prop-types';
import {
  startSetOffer,
  startSetOfferNews,
  startSetOfferPromo,
  resetOffer,
  resetOfferPromo,
} from '../../actions/offers';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import NewsList from '../../components/News/NewsList';
import NewsPromoList from '../../components/News/NewsPromoList';

class OfferNewsPage extends Component {
  static propTypes = {
    offer: object.isRequired,
    news: array.isRequired,
    promotions: array.isRequired,
    startSetOfferPromo: func.isRequired,
    startSetOfferNews: func.isRequired,
    startSetOffer: func.isRequired,
  };

  static defaultProps = {
    offer: {},
    news: [],
    promotions: [],
  };

  state = {
    loading: false,
    news: {
      limit: 25,
      offset: 0,
      page: 0,
    },
    promotions: {
      limit: 5,
      offset: 0,
      page: 0,
    },
  };

  componentDidMount() {
    const { match } = this.props;
    const id = parseInt(match.params.id, 10);

    if (!isNaN(id)) {
      const { news, promotions } = this.state;

      this.setState(() => ({ loading: true }));

      this.props
        .startSetOffer(id)
        .then(() => this.props.startSetOfferNews(id, { limit: news.limit, offset: news.offset }))
        .then(() =>
          this.props.startSetOfferPromo({ limit: promotions.limit, offset: promotions.offset }),
        )
        .then(() => this.setState(() => ({ loading: false })));
    }
  }

  componentWillUnmount() {
    this.props.resetOffer();
    this.props.resetOfferPromo();
  }

  render() {
    const { offer, news, promotions } = this.props;
    const { loading } = this.state;

    return (
      <Layout className="news-layout">
        <Layout.Col>
          <Card.Header>
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to="/offers/all">
                  <FormattedMessage id="offers.breadcrumb" defaultMessage="All offers" />
                </Link>
              </BreadcrumbItem>
              {offer && offer.id && offer.title && (
                <BreadcrumbItem>
                  <Link to={`/offers/${offer.id}`}>{offer.title}</Link>
                </BreadcrumbItem>
              )}
              <BreadcrumbItem>
                <FormattedMessage id="offer.news.title" defaultMessage="Offer News" />
              </BreadcrumbItem>
            </Breadcrumb>
          </Card.Header>
        </Layout.Col>
        <Layout.LeftCol className="left-col col">
          <Card className="card-loading-silent" loading={loading}>
            <Card.Body>
              <h3>
                <FormattedMessage id="offer.news.title" defaultMessage="Offer News" />
              </h3>
              <NewsList news={news} inOffer />
            </Card.Body>
          </Card>
        </Layout.LeftCol>

        <Layout.RightCol className="right-col col">
          <Card className="news-promo-wrapper">
            <Card.Header>
              <div className="card-with-controls-header-text mb-0">
                <FormattedMessage id="news.special.title" defaultMessage="Special offers" />
              </div>
            </Card.Header>
            <Card.Body className="no-padding">
              <NewsPromoList promotions={promotions} />
            </Card.Body>
          </Card>
        </Layout.RightCol>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  offer: state.offers.selected,
  news: state.offers.news,
  promotions: state.offers.promotions,
});

const mapDispatchToProps = (dispatch) => ({
  startSetOfferPromo: (params) => dispatch(startSetOfferPromo(params)),
  startSetOffer: (offerId) => dispatch(startSetOffer(offerId)),
  startSetOfferNews: (offerId, params) => dispatch(startSetOfferNews(offerId, params)),
  resetOffer: () => dispatch(resetOffer()),
  resetOfferPromo: () => dispatch(resetOfferPromo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferNewsPage);
